import { useEffect, useState } from 'react'
import { openStaffEvents, type StaffEvent } from '../api/staffEvents'

/**
 * The staff push channel, as a list a screen can draw.
 *
 * 🔴 NEWEST FIRST AND BOUNDED. A staffroom laptop is left signed in for a term;
 * an unbounded array on a long-lived connection is a leak with a UI attached.
 * Five is what fits above the fold — a sixth notice nobody scrolled to is a
 * notice nobody read.
 *
 * 🔴 THE LIST IS NOT PERSISTED, AND THAT IS THE HONEST SHAPE. These are frames
 * that arrived while this tab was open; a reload clears them. Persisting would
 * imply an inbox — a durable record of what a teacher has and has not seen —
 * and nothing on the server backs that claim. What IS durable is the thing the
 * frame points at: the holiday is in the calendar the screen loads either way.
 */
export function useStaffEvents(token: string | undefined, limit = 5): StaffEvent[] {
  const [events, setEvents] = useState<StaffEvent[]>([])

  useEffect(() => {
    /*
     * ⚠️ NO TOKEN, NO CONNECTION. A socket opened without one is disconnected by
     * the server on the handshake, so attempting it would be a reconnect loop
     * against a door that is never going to open.
     */
    if (token === undefined || token === '') return undefined

    return openStaffEvents(token, (event) => {
      setEvents((prev) => {
        /*
         * ⚠️ DEDUPED ON (type, at). socket.io redelivers on reconnect in some
         * transports, and a teacher watching the same closure appear three times
         * learns to distrust the panel. The pair is enough: two genuinely
         * distinct events of one type in the same millisecond is not a case this
         * product has.
         */
        if (prev.some((e) => e.type === event.type && e.at === event.at)) return prev
        return [event, ...prev].slice(0, limit)
      })
    })
  }, [token, limit])

  return events
}
